<template>
    <div class="bloque-general bloque-flecha-dorada">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="bloque-general__encabezado">
                        <h2>Próximos eventos</h2>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <EventoBox :item="item" v-for="(item, index) in eventos" :key="index" class="col-md-6 col-lg-4" />
            </div>

            <div class="row text-center">
                <div class="col-md-12">
                    <div class="bloque-boton bloque-boton--pb-none">
                        <Link href="/eventos" class="boton-principal boton-flecha">Ver más eventos</Link>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import EventoBox from '../../Shared/Eventos/EventoBox.vue'

export default {
    props: {
        eventos: Object,
    },
    components: { EventoBox, Link }
}
</script>
<style lang="">

</style>
